import "../Style/__login.scss";
import React, { useEffect, useState } from "react";
// import '../Form/LoginDesign.css'
import LoginEcosystem from "./LoginEcosystem";
import logo from "../Images/accountreelogo.png";
import axios from "axios";
import AuthForm from "./AuthForm";
import { loginWithSessionGuard } from "./HandleJWT";
import { useHistory } from "react-router-dom";
import { getLoginErrorMessage, LOGIN_TIMEOUT_MS } from "./loginErrors";
import { ApiLink } from "../APILink/ApiLink";
import "../Style/Button.css";
import { useLicense } from "../GetData/Context/LicenseContext";
import { startInactivityLogout, INACTIVITY_NOTICE_KEY } from "./inactivityService";
import { getLoginMonitoringHeaders } from "./accessMonitoringDevice";

const THEME_STORAGE_KEY = "accountree-theme";
const WORLD_CUP_START_DATE = new Date("2026-06-11T00:00:00");
const WORLD_CUP_END_DATE = new Date("2026-07-20T00:00:00");
const WORLD_CUP_LOGO_URL =
  "https://logowik.com/content/uploads/images/copa-mundial-de-la-fifa-20265186.logowik.com.webp";

const resolveStoredTheme = () => {
  if (typeof window === "undefined") {
    return "light";
  }

  const storedTheme = localStorage.getItem(THEME_STORAGE_KEY);
  if (storedTheme === "dark") {
    return "dark-green";
  }

  return storedTheme || "light";
};

export default function Login() {
  // const [errors, setErrors] = useState([]);
  // const { update } = useContext(AuthenticationContext);
  const { setLicenseInfo } = useLicense();

  const history = useHistory();

  const [loginError, setLoginError] = useState(null);
  const [inactivityNotice] = useState(() => sessionStorage.getItem(INACTIVITY_NOTICE_KEY));
  const [licenseMessage, setLicenseMessage] = useState(null);
  const [licenseType, setLicenseType] = useState(null); // "error" | "warning"
  const [showWorldCupBanner, setShowWorldCupBanner] = useState(false);

  useEffect(() => {
    sessionStorage.removeItem(INACTIVITY_NOTICE_KEY);
    const storedTheme = resolveStoredTheme();
    const isDarkTheme = storedTheme !== "light";
    const themeVariant = storedTheme === "dark-black" ? "black" : "green";

    document.documentElement.setAttribute("data-theme", isDarkTheme ? "dark" : "light");
    document.documentElement.setAttribute(
      "data-theme-variant",
      isDarkTheme ? themeVariant : "light"
    );
    document.documentElement.style.colorScheme = isDarkTheme ? "dark" : "light";

    const today = new Date();
    setShowWorldCupBanner(
      today >= WORLD_CUP_START_DATE && today < WORLD_CUP_END_DATE
    );
  }, []);

  //Ky kod ka qen aktiv, deri ne kohen kur fillova me i testu licensat
  // const login = async (credentials, setLoading) => {
  //   try {
  //     const res = await axios.post(ApiLink.API_URL + 'AuthProva/login', credentials);
  //     saveToken(res.data);
  //     history.push('/dashboard');
  //     window.location.reload();
  //   } catch (error) {
  //     if (error.response && error.response.status === 400) {
  //       errorAlert('Incorrect Email or Password');
  //     } else {
  //       errorAlert(error);
  //     }
  //   } finally {
  //     setLoading(false); // Reset loading state
  //   }
  // };

  const login = async (credentials, setLoading) => {
    try {
      if (navigator.onLine === false) {
        setLoginError(getLoginErrorMessage(null, false));
        return;
      }
      const res = await loginWithSessionGuard(() =>
        axios.post(
          ApiLink.API_URL + "AuthProva/login",
          credentials,
          { timeout: LOGIN_TIMEOUT_MS, headers: getLoginMonitoringHeaders() }
        )
      );
      setLicenseInfo({
        status: res.data.LicenseStatus,
        daysLeft: res.data.DaysLeft,
      });

      // console.log(res.data.DaysLeft);

      startInactivityLogout();
      history.push("/dashboard");

      // ⚠️ Paralajmërim për skadim
      if (res.data.licenseStatus === "ExpiringSoon") {
        setLicenseMessage(
          `Licenca juaj skadon për ${res.data.daysLeft} ditë. Ju lutemi kontaktoni për rinovim.`
        );
        setLicenseType("warning");
      } else {
        setLicenseMessage(null);
        setLicenseType(null);
      }
      window.location.reload();
    } catch (error) {
      setLoginError(getLoginErrorMessage(error, navigator.onLine !== false));
    } finally {
      setLoading(false);
    }
  };

  // const onSubmitHandler = (data) => {
  //   login(data)
  // }

  const onSubmitHandler = (data, setLoading) => {
    setLoginError(null);
    setLoading(true);
    login(data, setLoading);
  };

  return (
    <>
      <div className="Login_container Login_container--studio">
        <div className="Login_forms-container">
          <div className="Login_signin-signup">
            <div className="sign-in-form">
              {showWorldCupBanner && (
                <div className="Login_world-cup-logo" aria-label="FIFA World Cup 2026">
                  <img
                    src={WORLD_CUP_LOGO_URL}
                    alt="FIFA World Cup 2026"
                    loading="lazy"
                  />
                </div>
              )}
              <a
                className="Login_form-badge"
                href="https://acctree.net"
              >
                Faqja Kryesore
              </a>
              <div className="logo">
                <img src={logo} alt="webscript" />
              </div>
              <h1 className="Login_title">Mirë se u kthyet</h1>
              <p className="Login_subtitle">
                Hyni në platformë për të menaxhuar financat dhe raportet në një
                vend të vetëm.
              </p>
              {licenseMessage && (
                <div className={`Login_notice Login_notice--${licenseType || "warning"}`}>
                  {licenseMessage}
                </div>
              )}
              {inactivityNotice && (
                <div className="Login_notice Login_notice--warning" role="status">
                  {inactivityNotice}
                </div>
              )}
              {loginError && (
                <div className="login-studio__error" role="alert">
                  <strong>Hyrja nuk u krye</strong>
                  <span>{loginError}</span>
                </div>
              )}
              <AuthForm
                model={{ email: "", password: "" }}
                onSubmit={onSubmitHandler}
              />
              <a
                className="Login_footer-note"
                href="https://www.quantifynexus.com"
              >
                Developed by Quantify Nexus LLC
              </a>
            </div>
          </div>
        </div>

        <div className="panels-container">
          <div className="panel left-panel">
            <div className="Login_content">
              <div className="login-studio__eyebrow"><span /> ACCOUNTREE · EKOSISTEMI I BIZNESIT</div>
              <h2 className="login-studio__heading">Zëvendëso arkën fiskale<br /><span>me Arkën Digjitale.</span></h2>
              <p className="login-studio__intro">
                Nga kuponi te financat. Arka Digjitale dhe Accountree
                lidhin shitjet me menaxhimin e përditshëm të biznesit tuaj.
              </p>
            </div>
            {/* Original illustration retained at ../Form/img/photo.svg. */}
            <LoginEcosystem />
            <div className="login-studio__steps" aria-label="Si funksionon">
              <div><span>01</span><strong>Kryeni shitjen</strong><small>Me Arkën Digjitale</small></div>
              <div><span>02</span><strong>Të dhënat lidhen</strong><small>Printeri, ATK dhe Accountree</small></div>
              <div><span>03</span><strong>Menaxhoni biznesin</strong><small>Nga një platformë e vetme</small></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
